import { render, staticRenderFns } from "./LoadBalancer.vue?vue&type=template&id=4b3fc96d&"
import script from "./LoadBalancer.vue?vue&type=script&lang=js&"
export * from "./LoadBalancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports